<template>
    <div>
		<ul class="nav nav-tabs details-tabs" role="tablist">
		    <li role="presentation" class="active">
		        <a href="#overview" aria-controls="home" role="tab" data-toggle="tab">产品概述</a>
		    </li>
		    <li role="presentation">
		        <a href="#plain_weave" aria-controls="home" role="tab" data-toggle="tab">平织席型网</a>
		    </li>
			<li role="presentation">
			    <a href="#twill_weave" aria-controls="profile" role="tab" data-toggle="tab">斜织席型网</a>
			</li>
		</ul>
		<div class="tab-content">
			<div role="tabpanel" class="tab-pane active" id="overview">
				<img src="../assets/img/detail/xxw/1.jpg" width="100%" />
				<img src="../assets/img/detail/xxw/2.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/3.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/4.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/5.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/6.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/7.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/8.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/9.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/10.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/11.jpg" width="100%"/>
				<img src="../assets/img/detail/xxw/12.jpg" width="100%"/>
			</div>
			<div role="tabpanel" class="tab-pane active" id="plain_weave">
			    <div class="box-details">
					<p><strong>不锈钢席型网：</strong>学名密纹网，在长江的以南地区或国外也称为菏兰布。它是采用优良不锈钢丝编织而成。主要特点是经向、纬向丝径和密度有较大反差，因而网子厚度和过滤精度及使用寿命比方孔网有较明显的提高，它的过滤精度是方孔网布无法实现的。 </p>
					<p><strong>生产工艺流程：</strong>原料→整径→穿综片→穿钢扣→织网→质检→成品 </p>
					<p><strong>材质：</strong>SS304、SS304L、SS316、SS316L、SS430(根据现今编织技术的 不断提高又增加了纯镍丝、低碳钢丝等材质）</p>
					<p><strong>编织方式：</strong>平织</p>
					<p><strong>目数：</strong>32#-1575#</p>
					<p><strong>线径：</strong>0.63-0.02mm</p>
					<p><strong>孔径：</strong>0.023mm</p>
					<p><strong>过滤精度：</strong>0.315mm-0.005mm</p>
					<p><strong>网厚：</strong>0.135mm-2.32mm</p>
					<p><strong>网宽：</strong>1.0米/1.02米/1.22米/1.3米/1.6米/2米/3米</p>
			        <p><strong>不锈钢席型网用途：</strong>产品主要用于气体、液体过滤及其他介质分离；广泛用于精密压力过滤器、燃油过滤、真空过滤器、做滤芯原料、塑料行业、炼油、医药、制糖、石油、化工、化纤、橡胶、车胎制造、冶金、食品、卫生科研等行业。</p>
			    </div>
			    <div class="row">
			        <div class="col-md-6">
			            <div class="pic-box">
			                <img src="../assets/img/dw1.jpg"/>
			            </div>
			        </div>
			        <div class="col-md-6">
			            <div class="pic-box">
			                <img src="../assets/img/dw2.jpg"/>
			            </div>
			        </div>
			    </div>
			    <div class="row">
			        <div class="col-md-6">
			            <table class="table table-style table-bordered" cellspacing="" cellpadding="">
			                <thead>
			                <tr>
			                    <th>经目数 x 纬目数</th>
			                    <th>经丝径 x 纬丝径（mm）</th>
			                    <th>过滤精度（μm）</th>
			                    <th>开孔率（%）</th>
			                </tr>
			                </thead>
			                <tbody>
			                <tr>
			                    <td>7×40</td>
			                    <td>0.900 x 0.710</td>
			                    <td>347</td>
			                    <td>14.30</td>
			                </tr>
			                <tr>
			                    <td>7×44</td>
			                    <td>0.710 x 0.630</td>
			                    <td>319</td>
			                    <td>14.20</td>
			                </tr>
			                <tr>
			                    <td>8×45</td>
			                    <td>0.800 x 0.600</td>
			                    <td>310</td>
			                    <td>15.50</td>
			                </tr>
			                <tr>
			                    <td>8.5×60</td>
			                    <td>0.630 x 0.450</td>
			                    <td>296</td>
			                    <td>20.30</td>
			                </tr>
			                <tr>
			                    <td>8×85</td>
			                    <td>0.450 x 0.315</td>
			                    <td>275</td>
			                    <td>27.30</td>
			                </tr>
			                <tr>
			                    <td>10×90</td>
			                    <td>0.450 x 0.280</td>
			                    <td>249</td>
			                    <td>29.20</td>
			                </tr>
			                <tr>
			                    <td>10×76</td>
			                    <td>0.500 x 0.355</td>
			                    <td>248</td>
			                    <td>21.80</td>
			                </tr>
			                <tr>
			                    <td>12×86</td>
			                    <td>0.450 x 0.315</td>
			                    <td>211</td>
			                    <td>20.90</td>
			                </tr>
			                <tr>
			                    <td>12×64</td>
			                    <td>0.560 x 0.400</td>
			                    <td>211</td>
			                    <td>16.00</td>
			                </tr>
			                <tr>
			                    <td>12.5×76</td>
			                    <td>0.450 x 0.355</td>
			                    <td>192</td>
			                    <td>15.90</td>
			                </tr>
			                <tr>
			                    <td>14×100</td>
			                    <td>0.400 x 0.280</td>
			                    <td>182</td>
			                    <td>20.30</td>
			                </tr>
			                <tr>
			                    <td>14×110</td>
			                    <td>0.355 x 0.250</td>
			                    <td>177</td>
			                    <td>22.20</td>
			                </tr>
			                <tr>
			                    <td>14×76</td>
			                    <td>0.450 x 0.355</td>
			                    <td>173</td>
			                    <td>14.30</td>
			                </tr>
			                <tr>
			                    <td>16×100</td>
			                    <td>0.400 x 0.280</td>
			                    <td>160</td>
			                    <td>17.70</td>
			                </tr>
			                <tr>
			                    <td>17×120</td>
			                    <td>0.355 x 0.224</td>
			                    <td>155</td>
			                    <td>22.40</td>
			                </tr>
			                <tr>
			                    <td>16×120</td>
			                    <td>0.280 x 0.224</td>
			                    <td>145</td>
			                    <td>19.20</td>
			                </tr>
			                <tr>
			                    <td>20×140</td>
			                    <td>0.315 x 0.200</td>
			                    <td>133</td>
			                    <td>21.50</td>
			                </tr>
			                <tr>
			                    <td>20×170</td>
			                    <td>0.250 x 0.160</td>
			                    <td>130</td>
			                    <td>28.90</td>
			                </tr>
			                <tr>
			                    <td>20×110</td>
			                    <td>0.355 x 0.250</td>
			                    <td>126</td>
			                    <td>15.30</td>
			                </tr>
			                <tr>
			                    <td>22×120</td>
			                    <td>0.315 x 0.224</td>
			                    <td>115</td>
			                    <td>15.50</td>
			                </tr>
			                <tr>
			                    <td>25×140</td>
			                    <td>0.280 x 0.200</td>
			                    <td>100</td>
			                    <td>15.20</td>
			                </tr>
			                </tbody>
			            </table>
			        </div>
			        <div class="col-md-6">
			            <table class="table table-style table-bordered" cellspacing="" cellpadding="">
			                <thead>
			                <tr>
			                    <th>经目数 x 纬目数</th>
			                    <th>经丝径 x 纬丝径（mm）</th>
			                    <th>过滤精度（μm）</th>
			                    <th>开孔率（%）</th>
			                </tr>
			                </thead>
			                <tbody>
			                <tr>
			                    <td>24×110</td>
			                    <td>0.355 x 0.250</td>
			                    <td>97</td>
			                    <td>11.30</td>
			                </tr>
			                <tr>
			                    <td>28×150</td>
			                    <td>0.280 x 0.180</td>
			                    <td>92</td>
			                    <td>15.90</td>
			                </tr>
			                <tr>
			                    <td>30×150</td>
			                    <td>0.250 x 0.180</td>
			                    <td>82</td>
			                    <td>13.50</td>
			                </tr>
			                <tr>
			                    <td>30×140</td>
			                    <td>0.315 x 0.200</td>
			                    <td>77</td>
			                    <td>11.40</td>
			                </tr>
			                <tr>
			                    <td>40×200</td>
			                    <td>0.180 x 0.135</td>
			                    <td>63</td>
			                    <td>15.40</td>
			                </tr>
			                <tr>
			                    <td>45×250</td>
			                    <td>0.160 x 0.110</td>
			                    <td>56</td>
			                    <td>15.20</td>
			                </tr>
			                <tr>
			                    <td>50×300</td>
			                    <td>0.160 x 0.090</td>
			                    <td>55</td>
			                    <td>20.00</td>
			                </tr>
			                <tr>
			                    <td>60×500</td>
			                    <td>0.140 x 0.055</td>
			                    <td>51</td>
			                    <td>34.10</td>
			                </tr>
			                <tr>
			                    <td>50×270</td>
			                    <td>0.140 x 0.100</td>
			                    <td>50</td>
			                    <td>15.20</td>
			                </tr>
			                <tr>
			                    <td>70×930</td>
			                    <td>0.100 x 0.030</td>
			                    <td>30</td>
			                    <td>36.20</td>
			                </tr>
			                <tr>
			                    <td>65×390</td>
			                    <td>0.125 x 0.071</td>
			                    <td>42</td>
			                    <td>19.10</td>
			                </tr>
			                <tr>
			                    <td>60×300</td>
			                    <td>0.140 x 0.090</td>
			                    <td>41</td>
			                    <td>14.10</td>
			                </tr>
			                <tr>
			                    <td>80×700</td>
			                    <td>0.125 x 0.040</td>
			                    <td>40</td>
			                    <td>38.10</td>
			                </tr>
			                <tr>
			                    <td>60×270</td>
			                    <td>0.140 x 0.100</td>
			                    <td>39</td>
			                    <td>11.20</td>
			                </tr>
			                <tr>
			                    <td>77×560</td>
			                    <td>0.140 x 0.050</td>
			                    <td>38</td>
			                    <td>27.50</td>
			                </tr>
			                <tr>
			                    <td>80×600</td>
			                    <td>0.100 x 0.045</td>
			                    <td>37</td>
			                    <td>29.80</td>
			                </tr>
			                <tr>
			                    <td>70×390</td>
			                    <td>0.112 x 0.071</td>
			                    <td>37</td>
			                    <td>16.30</td>
			                </tr>
			                <tr>
			                    <td>65×750</td>
			                    <td>0.100 x 0.036</td>
			                    <td>36</td>
			                    <td>37.10</td>
			                </tr>
			                <tr>
			                    <td>70×340</td>
			                    <td>0.125 x 0.080</td>
			                    <td>35</td>
			                    <td>13.20</td>
			                </tr>
			                <tr>
			                    <td>80×430</td>
			                    <td>0.125 x 0.063</td>
			                    <td>32</td>
			                    <td>16.60</td>
			                </tr>
			                <tr>
			                    <td>118×750</td>
			                    <td>0.063 x 0.036</td>
			                    <td>23</td>
			                    <td>21.50</td>
			                </tr>
			                </tbody>
			            </table>
			        </div>
			    </div>
			</div>
			<div role="tabpanel" class="tab-pane" id="twill_weave">
			    <div class="box-details">
					<p><strong>不锈钢斜织席型网：</strong>每根径丝交叉地在一根纬丝上下穿过每根纬丝交叉地在一根径丝上下穿过的编织方式。纬向丝径相加值25.4mm≤a≤28mm，不锈钢斜纹网具有过滤性能稳定、耐用，精细等特点、网面平整、耐酸碱腐蚀、造价相对较低。可以和冲孔网一起加工过滤筒等过滤产品。 </p>
					<p><strong>生产工艺流程：</strong>原料→整径→穿综片→穿钢扣→织网→质检→成品 </p>
					<p><strong>材质：</strong>SS304  SS304L、SS316、SS316L、SS430(根据现今编织技术的 不断提高又增加了纯镍丝、低碳钢丝等材质）</p>
					<p><strong>编织方式：</strong>斜织</p>
					<p><strong>目数：</strong>20目-635目</p>
					<p><strong>线径：</strong>0.6-0.02mm</p>
					<p><strong>孔径：</strong>1.0-0.02mm</p>
					<p><strong>过滤精度：</strong>1.0mm-0.3um</p>
					<p><strong>网宽：</strong>1.0米/1.02米/1.22米/1.3米/1.6米/2米/3米</p>
					<p><strong>用途：</strong>航天、石油、化工，医药，食品制造等行业，陶瓷泥浆及粉料过滤，一般用在石油和矿业的振动筛网。</p>
			    </div>
			    <div class="row">
			        <div class="col-md-6">
			            <div class="pic-box">
			                <img src="../assets/img/dw3.jpg"/>
			            </div>
			        </div>
			        <div class="col-md-6">
			            <div class="pic-box">
			                <img src="../assets/img/dw4.jpg"/>
			            </div>
			        </div>
			    </div>
			    <div class="row">
			        <div class="col-md-6">
			            <table class="table table-style table-bordered" cellspacing="" cellpadding="">
			                <thead>
			                <tr>
			                    <th>经目数 x 纬目数</th>
			                    <th>经丝径 x 纬丝径（mm）</th>
			                    <th>过滤精度（μm）</th>
			                    <th>开孔率（%）</th>
			                </tr>
			                </thead>
			                <tbody>
			                <tr>
			                    <td>20×270</td>
			                    <td>0.250 x 0.200</td>
			                    <td>119</td>
			                    <td>17.60</td>
			                </tr>
			                <tr>
			                    <td>20×200</td>
			                    <td>0.355 x 0.280</td>
			                    <td>118</td>
			                    <td>12.10</td>
			                </tr>
			                <tr>
			                    <td>24×300</td>
			                    <td>0.280 x 0.180</td>
			                    <td>110</td>
			                    <td>19.60</td>
			                </tr>
			                <tr>
			                    <td>20×150</td>
			                    <td>0.450 x 0.355</td>
			                    <td>101</td>
			                    <td>7.50</td>
			                </tr>
			                <tr>
			                    <td>20×340</td>
			                    <td>0.280 x 0.160</td>
			                    <td>89</td>
			                    <td>17.90</td>
			                </tr>
			                <tr>
			                    <td>30×270</td>
			                    <td>0.280 x 0.200</td>
			                    <td>77</td>
			                    <td>11.20</td>
			                </tr>
			                <tr>
			                    <td>40×540</td>
			                    <td>0.180 x 0.100</td>
			                    <td>70</td>
			                    <td>23.50</td>
			                </tr>
			                <tr>
			                    <td>40×430</td>
			                    <td>0.180 x 0.125</td>
			                    <td>63</td>
			                    <td>15.40</td>
			                </tr>
			                <tr>
			                    <td>50×600</td>
			                    <td>0.125 x 0.090</td>
			                    <td>51</td>
			                    <td>17.20</td>
			                </tr>
			                <tr>
			                    <td>50×500</td>
			                    <td>0.140 x 0.110</td>
			                    <td>47</td>
			                    <td>12.00</td>
			                </tr>
			                <tr>
			                    <td>65×600</td>
			                    <td>0.140 x 0.090</td>
			                    <td>36</td>
			                    <td>12.00</td>
			                </tr>
			                <tr>
			                    <td>70×600</td>
			                    <td>0.140 x 0.090</td>
			                    <td>31</td>
			                    <td>10.10</td>
			                </tr>
			                <tr>
			                    <td>78×760</td>
			                    <td>0.112 x 0.071</td>
			                    <td>31</td>
			                    <td>13.50</td>
			                </tr>
			                <tr>
			                    <td>78×680</td>
			                    <td>0.112 x 0.080</td>
			                    <td>29</td>
			                    <td>10.30</td>
			                </tr>
			                <tr>
			                    <td>80×680</td>
			                    <td>0.112 x 0.080</td>
			                    <td>28</td>
			                    <td>9.80</td>
			                </tr>
			                <tr>
			                    <td>90×850</td>
			                    <td>0.100 x 0.063</td>
			                    <td>26</td>
			                    <td>12.70</td>
			                </tr>
			                <tr>
			                    <td>90×760</td>
			                    <td>0.100 x 0.071</td>
			                    <td>24</td>
			                    <td>9.60</td>
			                </tr>
			                <tr>
			                    <td>100×850</td>
			                    <td>0.100 x 0.063</td>
			                    <td>22</td>
			                    <td>10.00</td>
			                </tr>
			                <tr>
			                    <td>200×600</td>
			                    <td>0.061 x 0.046</td>
			                    <td>21</td>
			                    <td>13.40</td>
			                </tr>
			                <tr>
			                    <td>130×1500</td>
			                    <td>0.063 x 0.036</td>
			                    <td>21</td>
			                    <td>18.60</td>
			                </tr>
			                <tr>
			                    <td>100×760</td>
			                    <td>0.100 x 0.071</td>
			                    <td>20</td>
			                    <td>7.40</td>
			                </tr>
			                </tbody>
			            </table>
			        </div>
			        <div class="col-md-6">
			            <table class="table table-style table-bordered" cellspacing="" cellpadding="">
			                <thead>
			                <tr>
			                    <th>经目数 x 纬目数</th>
			                    <th>经丝径 x 纬丝径（mm）</th>
			                    <th>过滤精度（μm）</th>
			                    <th>开孔率（%）</th>
			                </tr>
			                </thead>
			                <tbody>
			                <tr>
			                    <td>130×1200</td>
			                    <td>0.071 x 0.045</td>
			                    <td>18</td>
			                    <td>12.00</td>
			                </tr>
			                <tr>
			                    <td>130×1100</td>
			                    <td>0.071 x 0.050</td>
			                    <td>17</td>
			                    <td>9.40</td>
			                </tr>
			                <tr>
			                    <td>165×800</td>
			                    <td>0.071 x 0.051</td>
			                    <td>17</td>
			                    <td>12.70</td>
			                </tr>
			                <tr>
			                    <td>150×1400</td>
			                    <td>0.063 x 0.040</td>
			                    <td>15</td>
			                    <td>11.40</td>
			                </tr>
			                <tr>
			                    <td>160×1500</td>
			                    <td>0.063 x 0.036</td>
			                    <td>15</td>
			                    <td>12.40</td>
			                </tr>
			                <tr>
			                    <td>165×1500</td>
			                    <td>0.063 x 0.036</td>
			                    <td>14</td>
			                    <td>11.40</td>
			                </tr>
			                <tr>
			                    <td>174×1700</td>
			                    <td>0.063 x 0.032</td>
			                    <td>13</td>
			                    <td>12.90</td>
			                </tr>
			                <tr>
			                    <td>165×1400</td>
			                    <td>0.063 x 0.040</td>
			                    <td>13</td>
			                    <td>8.80</td>
			                </tr>
			                <tr>
			                    <td>174×1400</td>
			                    <td>0.063 x 0.040</td>
			                    <td>11</td>
			                    <td>7.40</td>
			                </tr>
			                <tr>
			                    <td>203×1600</td>
			                    <td>0.050 x 0.032</td>
			                    <td>10</td>
			                    <td>9.30</td>
			                </tr>
			                <tr>
			                    <td>216×1800</td>
			                    <td>0.045 x 0.030</td>
			                    <td>10</td>
			                    <td>9.40</td>
			                </tr>
			                <tr>
			                    <td>203×1500</td>
			                    <td>0.056 x 0.036</td>
			                    <td>9</td>
			                    <td>6.20</td>
			                </tr>
			                <tr>
			                    <td>250×1900</td>
			                    <td>0.040 x 0.028</td>
			                    <td>8</td>
			                    <td>7.80</td>
			                </tr>
			                <tr>
			                    <td>250×1600</td>
			                    <td>0.050 x 0.032</td>
			                    <td>8</td>
			                    <td>3.80</td>
			                </tr>
			                <tr>
			                    <td>285×2100</td>
			                    <td>0.036 x 0.025</td>
			                    <td>7</td>
			                    <td>7.20</td>
			                </tr>
			                <tr>
			                    <td>300×2100</td>
			                    <td>0.036 x 0.025</td>
			                    <td>6</td>
			                    <td>6.00</td>
			                </tr>
			                <tr>
			                    <td>317×2100</td>
			                    <td>0.036 x 0.025</td>
			                    <td>5</td>
			                    <td>4.70</td>
			                </tr>
			                <tr>
			                    <td>325×2300</td>
			                    <td>0.036 x 0.024</td>
			                    <td>4</td>
			                    <td>4.20</td>
			                </tr>
			                <tr>
			                    <td>363×2300</td>
			                    <td>0.032 x 0.022</td>
			                    <td>4</td>
			                    <td>4.50</td>
			                </tr>
			                <tr>
			                    <td>400×2800</td>
			                    <td>0.028 x 0.020</td>
			                    <td>4</td>
			                    <td>4.70</td>
			                </tr>
			                <tr>
			                    <td>500×3500</td>
			                    <td>0.025 x 0.015</td>
			                    <td>3</td>
			                    <td>4.90</td>
			                </tr>
			                </tbody>
			            </table>
			        </div>
			    </div>
			</div>
		</div>
		
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>